import { Switch } from 'Switch';
import { SettingRow } from './SettingRow';

type Props = {
    name: string;
    title: string;
    description: string;
    descriptionExtra?: string;
    isSelected: boolean;
    onValueChange: (value: boolean) => void;
};

export function PreferenceSwitchRow({ name, title, description, descriptionExtra, isSelected, onValueChange }: Props) {
    return (
        <SettingRow title={title} description={description} descriptionExtra={descriptionExtra}>
            <Switch name={name} aria-label={title} isSelected={isSelected} onValueChange={onValueChange} />
        </SettingRow>
    );
}
